import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { BulkActionTypes } from './typings'
import { useBulkActionContext } from './BulkActionContext'
import { ButtonWithTooltip } from '@sales-center/components'
import { buttonClasses } from '@mui/material/Button'

const styles = {
  outlined: { backgroundColor: (theme: Theme) => theme.palette.common.white },
}

type Props = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  type: BulkActionTypes
  helperText: string
  hasPermission: boolean
  errorString: string
  dataTestId?: string
  children: React.ReactNode
}

export function BulkActionButton(props: Props) {
  const {
    onClick = () => {},
    type,
    children,
    errorString,
    hasPermission,
    dataTestId,
  } = props

  const {
    state: { activeBulkAction },
    dispatch,
  } = useBulkActionContext()

  const active = React.useMemo(
    () => type === activeBulkAction,
    [activeBulkAction, type],
  )

  const clickHandler = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      dispatch({ type: 'setActive', payload: active ? undefined : type })
      onClick(e)
    },
    [active, dispatch, onClick, type],
  )

  return (
    <ButtonWithTooltip
      showTooltip
      tooltipTitle={hasPermission ? '' : errorString}
      onClick={clickHandler}
      sx={{ [`&.${buttonClasses.outlined}`]: { ...styles.outlined } }}
      variant={active ? 'contained' : 'outlined'}
      color="primary"
      disableFocusRipple
      disableTouchRipple
      disabled={!hasPermission}
      data-test-id={`bulkActBtn-${dataTestId}`}
    >
      {children}
    </ButtonWithTooltip>
  )
}
BulkActionButton.displayName = 'BulkActionButton'
